import { styled } from "@mui/material";

export const UpdateCustomerWrapper = styled("form")(({ theme }) => {
    return {
        display: "flex",
        flexDirection: "column",
        gap: "var(--flex-gap)",
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
        "& .file-badge": {
            width: '55px',
            height: '48px',
            borderRadius: '50%',
            objectFit: 'cover'
        },
    }
})